import {createContext, useEffect, useRef, useState} from "react";
import {initialOptions} from "../utils/georeferenced-search-utils.js";

export const GeoreferencedSearchContext = createContext(undefined);

const GeoreferencedSearchProvider = ({children}) => {
    const [data, setData] = useState([]);
    const [selection, setSelection] = useState({
        type: 'none',
        data: null
    });
    const [currentPassage, setCurrentPassage] = useState(0);
    const [options, setOptions] = useState(initialOptions);
    const [registryVersion, setRegistryVersion] = useState(0);
    const [activePlates, setActivePlates] = useState(new Set());
    const [orderedData, setOrderedData] = useState([]);
    const [hiddenDetails, setHiddenDetails] = useState(false);
    const mapZoomController = useRef(0);
    const gridApi = useRef(null);
    const centerOnSelectionRef = useRef(false);
    const colorRegistry = useRef({
        default: new Map(),
        grouped: new Map()
    });

    const zIndexCounter = useRef(100);
    const zIndexRegistry = useRef(new Map())
    const detailController = (action) => {
        if(!options.groupByPlate) return;

        let current = currentPassage;

        if(action === "NEXT" && currentPassage < selection.data.passages.length - 1) {
            current++;
            setCurrentPassage(current);
        }

        if(action === "PREVIOUS" && currentPassage > 0){
            current--;
            setCurrentPassage(current)
        }
    }

    useEffect(() => {
        if (!selection.data) return;

        const Z_STEP = 10;
        const ACTIVE_OFFSET = 2;
        const PASSIVE_OFFSET = 1;

        zIndexCounter.current += Z_STEP;
        const baseZ = zIndexCounter.current;

        if (options.groupByPlate && Array.isArray(selection.data.passages)) {
            selection.data.passages.forEach((p, index) => {
                const z =
                    index === currentPassage
                        ? baseZ + ACTIVE_OFFSET
                        : baseZ + PASSIVE_OFFSET;

                zIndexRegistry.current.set(p.id, z);
            });
        } else {
            zIndexRegistry.current.set(selection.data.id, baseZ + ACTIVE_OFFSET);
        }

        setRegistryVersion(v => v + 1);
    }, [currentPassage, selection, options.groupByPlate]);

    function syncOrderedData(api) {
        const ordered = [];
        api.forEachNodeAfterFilterAndSort(node => {
            ordered.push(node.data);
        });
        return ordered;
    }

    const onGridReady = (params) => {
        gridApi.current = params.api;

        const initialOrder = syncOrderedData(params.api);
        setOrderedData(initialOrder);
    }

    return(
        <GeoreferencedSearchContext.Provider value={{data, setData, currentPassage, setCurrentPassage, orderedData, setOrderedData, mapZoomController,
            centerOnSelectionRef, options, setOptions, colorRegistry, zIndexRegistry, zIndexCounter, onGridReady, gridApi, syncOrderedData, hiddenDetails,
            setHiddenDetails, registryVersion, setRegistryVersion, detailController, activePlates, setActivePlates, setSelection, selection}}>
            {children}
        </GeoreferencedSearchContext.Provider>
    )
}

export default GeoreferencedSearchProvider;